import { useErrorHandler } from 'components/ErrorHandler/ErrorHandlerContext';
import { useRootStore } from 'models/rootModel';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getSelectedSettings, getTADomainValues, getTenant, getUser } from 'utils/api';
import { loadAllDomains } from 'utils/domainLoader';

export const Configuration = ({ children }) => {
  const rootStore = useRootStore();
  const [loaded, setLoaded] = React.useState(false);
  const [t] = useTranslation();
  const { addError } = useErrorHandler();

  React.useEffect(() => {
    const setup = async () => {
      try {
        const settings = await getSelectedSettings([
          'ExternalApplicationSettings',
          'MapConfiguration',
          'GeneralSettings',
          'MapUrlSettings'
        ]);
        rootStore.settings.setSettings(settings);
      } catch (error) {
        addError(error, t('general:errorSettings'));
      }

      loadAllDomains()
        .then(domains => {
          rootStore.setDomains(domains);
        })
        .catch(error => {
          addError(error, t('general:errorDomains'));
        });

      getTADomainValues()
        .then(taDomains => {
          rootStore.setTADomains(taDomains);
        })
        .catch(error => {
          addError(error, t('general:errorDomains'));
        });

      try {
        const user = await getUser();
        rootStore.setUser(user);
      } catch (error) {
        addError(error, t('general:errorUser'));
      }

      try {
        const tenant = await getTenant(rootStore.municipality.tenantId);
        rootStore.setMunicipality(tenant);
      } catch (error) {
        addError(error, t('general:errorTenant'));
      }

      setLoaded(true);
    };

    if (!loaded) {
      setup();
    }
  }, [loaded, rootStore, addError, t]);

  return loaded ? children : null;
};
